import React from "react";
import { LANGUAGES, setLanguage, t, useLanguage } from "../i18n";

/** Compact language switch; the choice is remembered in this browser. */
export function LanguagePicker({ style, className }) {
  const lang = useLanguage();
  return (
    <label className={className} style={{ display: "inline-flex", alignItems: "center", gap: 6, ...style }}>
      <i className="fa-solid fa-language" aria-hidden="true" />
      <span className="sr-only">{t("language.label")}</span>
      <select
        value={lang}
        onChange={(e) => setLanguage(e.target.value)}
        aria-label={t("language.label")}
        style={{ border: "1px solid #d7cdef", borderRadius: 8, padding: "4px 6px", background: "#fff" }}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
